import React, { useState, useEffect } from "react";
import "./FilterSidebar.css";
import Accordion from "react-bootstrap/Accordion";

export default function FilterSidebar({ 
  open, 
  setOpen, 
  categories = [], 
  selectedCategories = [], 
  setSelectedCategories, 
  maxPrice = 20000, 
  setMaxPrice 
}) {
  const [tempSelectedCategories, setTempSelectedCategories] = useState([]);
  const [tempMaxPrice, setTempMaxPrice] = useState(20000);

  // Sync temporary states when the sidebar is opened or props change
  useEffect(() => {
    if (open) {
      setTempSelectedCategories(selectedCategories);
      setTempMaxPrice(maxPrice);
    }
  }, [open, selectedCategories, maxPrice]);

  const handleCategoryToggle = (id) => {
    setTempSelectedCategories(prev => {
      if (prev.includes(id)) {
        return prev.filter(item => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const handleApplyFilter = () => {
    setSelectedCategories(tempSelectedCategories);
    setMaxPrice(tempMaxPrice);
    setOpen(false);
  };

  const handleClearAll = () => {
    setTempSelectedCategories([]);
    setTempMaxPrice(20000);
    setSelectedCategories([]);
    setMaxPrice(20000);
    setOpen(false);
  };

  // Build category hierarchy: parent categories have parent_id = 0 or null
  const parentCategories = categories.filter(c => !c.parent_id || Number(c.parent_id) === 0);
  
  const getSubcategories = (parentId) => {
    return categories.filter(c => Number(c.parent_id) === Number(parentId));
  };

  return (
    <>
      <div className={`base ${open ? "active" : ""}`}>
        <div className="sidebar_filter_main">
          <div className="sidebar_filter_header">
            <h1>Filters</h1>
            <button className="close_btn" onClick={() => setOpen(false)}>
              ✕
            </button>
          </div>
          <div className="filter_accord">
            <Accordion defaultActiveKey={["0", "1"]} alwaysOpen>
              {/* Category Filter */}
              <Accordion.Item eventKey="0">
                <Accordion.Header>Category</Accordion.Header>
                <Accordion.Body>
                  <div className="filter_check_outer" style={{ maxHeight: "350px", overflowY: "auto" }}>
                    {parentCategories.map((parent) => {
                      const subcats = getSubcategories(parent.id);
                      return (
                        <div key={parent.id} className="category-group mb-3">
                          <div className="form-check d-flex align-items-center">
                            <input
                              className="form-check-input me-2"
                              type="checkbox"
                              checked={tempSelectedCategories.includes(parent.id)}
                              onChange={() => handleCategoryToggle(parent.id)}
                              id={`cat-check-${parent.id}`}
                            />
                            <label 
                              className="form-check-label fw-bold text-dark" 
                              htmlFor={`cat-check-${parent.id}`}
                              style={{ cursor: "pointer" }}
                            >
                              {parent.name}
                            </label>
                          </div>
                          
                          {subcats.length > 0 && (
                            <div className="subcategory-list ms-4 ps-1 mt-1 border-start border-light-subtle">
                              {subcats.map((sub) => (
                                <div className="form-check d-flex align-items-center mb-1" key={sub.id}>
                                  <input
                                    className="form-check-input me-2"
                                    type="checkbox"
                                    checked={tempSelectedCategories.includes(sub.id)}
                                    onChange={() => handleCategoryToggle(sub.id)}
                                    id={`cat-check-${sub.id}`}
                                  />
                                  <label 
                                    className="form-check-label text-muted" 
                                    htmlFor={`cat-check-${sub.id}`}
                                    style={{ cursor: "pointer", fontSize: "14px" }}
                                  >
                                    {sub.name}
                                  </label>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              {/* Price Filter */}
              <Accordion.Item eventKey="1">
                <Accordion.Header>Price Range</Accordion.Header>
                <Accordion.Body>
                  <div className="price_range_outer pt-2 pb-3">
                    <input
                      type="range"
                      className="form-range"
                      min="0"
                      max="20000"
                      step="500"
                      value={tempMaxPrice}
                      onChange={(e) => setTempMaxPrice(Number(e.target.value))}
                      id="price-range-slider"
                    />
                    <div className="d-flex justify-content-between mt-2" style={{ fontSize: "14px", color: "#6c757d" }}>
                      <span>₹0</span>
                      <span className="fw-semibold text-dark">Up to ₹{tempMaxPrice.toLocaleString('en-IN')}</span>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="d-flex gap-2 mt-4 px-1 pb-5">
              <button 
                type="button" 
                className="btn btn-outline-dark flex-fill py-2" 
                onClick={handleClearAll}
                style={{ borderRadius: 0, fontFamily: 'var(--font-primary)', fontWeight: '500' }}
              >
                Clear All
              </button>
              <button 
                type="button" 
                className="btn btn-dark flex-fill py-2" 
                onClick={handleApplyFilter}
                style={{ borderRadius: 0, fontFamily: 'var(--font-primary)', fontWeight: '500' }}
              >
                Apply Filter
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

